import { useState, useCallback } from 'react';
import { ToastType } from '@/components/ui';

interface ToastState {
  message: string | null;
  type: ToastType;
}

export function useToast() {
  const [toast, setToast] = useState<ToastState>({
    message: null,
    type: 'success'
  });

  const showToast = useCallback((message: string, type: ToastType = 'success') => {
    setToast({ message, type });
  }, []);

  const clearToast = useCallback(() => {
    setToast({ message: null, type: 'success' });
  }, []);

  return {
    toast,
    showToast,
    clearToast,
  };
}